import PayGatewayService from '@/services/payment-gateway.js'

export default {
  getPaymentGateway ({commit}, params) {
    return new Promise((resolve, reject) => {
      PayGatewayService.getPaymentGateway({
        params,
        headers: {
          'Authorization': localStorage.token
        }
      })
        .then(response => {
          const datas = response.data.data

          datas.map(item => {
            if(item.file !== null) {
              item.file = process.env.VUE_APP_STORAGE + '/' + item.file
            }
          })
          commit('SET_DATA_PAYMENT_GATEWAY', response.data.data)
          resolve(response.data.data)
        })
        .catch(e => reject(e))
    })
  },
  changePaymentGateway({commit}, data = []) {
    commit('SET_ACTIVE_PAYMENT_GATEWAY', data)
  },
  setSelectedPayment({commit}, data) {
    commit('SET_SELECTED_PAYMENT', data)
  },
  deleteSelectedPayment({commit}) {
    commit('DELETE_SELECTED_PAYMENT')
  }
}
